import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CtaButton } from "./CtaButton";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 1.1, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-[90] transition-colors duration-500 ${
        scrolled ? "border-b border-[#d4af37]/25 bg-[#0a0a0b]/85 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <div className="h-[2px] w-full gold-metallic" />
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 sm:px-8 lg:px-12">
        <a href="/" data-testid="nav-brand" className="flex flex-col leading-none">
          <span className="font-['Playfair_Display'] text-lg font-semibold tracking-tight text-[#f5f5f0]">
            Shabz Fazl
          </span>
          <span className="font-['IBM_Plex_Mono'] text-[9px] uppercase tracking-[0.34em] text-[#d4af37]">
            6 Figure Trading Coach
          </span>
        </a>
        <nav className="hidden items-center gap-9 md:flex">
          {[
            ["The Wall", "/#wall"],
            ["The Life", "/#life"],
            ["The Work", "/#work"],
            ["Forex", "/forex"],
            ["FAQ", "/#faq"],
          ].map(([label, href]) => (
            <a
              key={href}
              href={href}
              data-testid={`nav-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.24em] text-[#a1a1aa] transition-colors hover:text-[#d4af37]"
            >
              {label}
            </a>
          ))}
        </nav>
        <CtaButton testid="nav-cta" className="hidden py-2.5 text-xs sm:inline-flex" label="Message Shabz" />
      </div>
    </motion.header>
  );
};
